export function ChartLegend({ items, hidden, onToggle }) {
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="chart-legend">
      {items.map((it) => {
        const off = hidden.has(it.key);
        return (
          <button key={it.key} type="button" onClick={() => onToggle(it.key)} aria-pressed={!off}
                  className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded border hairline text-[11px] transition-opacity duration-150 ${off ? "opacity-40 line-through" : ""}`}
                  data-testid={`chart-legend-${it.key}`}>
            <svg width="18" height="8" aria-hidden="true">
              {it.bar
                ? <rect x="1" y="0" width="16" height="8" fill={it.color} />
                : <line x1="0" y1="4" x2="18" y2="4" stroke={it.color} strokeWidth="2.5" strokeDasharray={it.dash || undefined} />}
              {it.hatch && <line x1="4" y1="8" x2="12" y2="0" stroke="#fff" strokeOpacity="0.7" strokeWidth="2" />}
            </svg>
            {it.label}
          </button>
        );
      })}
    </div>
  );
}
